import { Avatar, type AvatarProps } from '@mui/material';
import useProfilePicture from '@/components/UserAvatar/useProfilePicture';
import { type UserSummary } from '@/lib/types';

type AutomatedAvatarProps = Omit<AvatarProps, 'src' | 'children'> & {
  user: UserSummary;
};

const AutomatedAvatar = ({ user, ...props }: AutomatedAvatarProps) => {
  const profilePicture = useProfilePicture(user);

  return (
    <Avatar src={profilePicture ?? undefined} {...props}>
      {user.name.charAt(0)}
    </Avatar>
  );
};

export default AutomatedAvatar;
